import { formatDistanceToNow } from "date-fns";
import { Sparkles, History } from "lucide-react";
import { FORGE } from "@/constants/testIds";

export default function HistorySidebar({
    history,
    activeRunId,
    onSelect,
    onNewRun,
}) {
    return (
        <aside
            data-testid={FORGE.historySidebar}
            className="w-full lg:w-72 shrink-0 lg:sticky lg:top-[210px] lg:self-start"
        >
            <div className="bg-[color:var(--surface-hover)] rounded-lg border border-[color:var(--border-subtle)] p-5">
                <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                        <History
                            size={14}
                            className="text-[color:var(--profecia-gold)]"
                        />
                        <h3 className="font-serif text-lg text-[color:var(--text-main)] leading-none">
                            Run History
                        </h3>
                    </div>
                    <button
                        data-testid={FORGE.newRunButton}
                        onClick={onNewRun}
                        className="text-[10px] uppercase tracking-widest font-mono text-[color:var(--profecia-gold)] hover:text-[color:var(--profecia-gold-hover)] transition-colors"
                    >
                        + new
                    </button>
                </div>

                {history.length === 0 ? (
                    <div className="text-center py-10 px-2">
                        <Sparkles
                            size={20}
                            className="mx-auto text-[color:var(--text-muted)] opacity-40 mb-2"
                        />
                        <p className="text-xs text-[color:var(--text-muted)] font-light leading-relaxed">
                            No runs yet.
                            <br />
                            Your prompt history will appear here.
                        </p>
                    </div>
                ) : (
                    <ul className="space-y-2 max-h-[520px] overflow-y-auto pr-1">
                        {history.map((run) => {
                            const isActive = run.id === activeRunId;
                            return (
                                <li key={run.id}>
                                    <button
                                        data-testid={FORGE.historyItem(run.id)}
                                        onClick={() => onSelect(run.id)}
                                        className={`w-full text-left px-3 py-2.5 rounded-md border transition-colors duration-200 ${
                                            isActive
                                                ? "bg-white border-[color:var(--profecia-gold-subtle)]"
                                                : "bg-white/50 border-transparent hover:bg-white hover:border-[color:var(--border-subtle)]"
                                        }`}
                                    >
                                        <div className="text-[10px] uppercase tracking-widest font-mono text-[color:var(--profecia-gold)] mb-1">
                                            {run.brand}
                                        </div>
                                        <div className="text-xs text-[color:var(--text-main)] line-clamp-2 leading-snug font-light">
                                            {run.brief}
                                        </div>
                                        <div className="text-[10px] text-[color:var(--text-muted)] mt-1 font-mono">
                                            {(() => {
                                                try {
                                                    return formatDistanceToNow(
                                                        new Date(
                                                            run.created_at,
                                                        ),
                                                        { addSuffix: true },
                                                    );
                                                } catch {
                                                    return "";
                                                }
                                            })()}
                                        </div>
                                    </button>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </aside>
    );
}
